import './../sass/style.scss';
import 'bootstrap';
import fontawesome from '@fortawesome/fontawesome';
import light from '@fortawesome/fontawesome-pro-light';
import brands from '@fortawesome/fontawesome-free-brands';
import Flickity from 'flickity';
import Headroom from 'headroom.js';
import 'isotope-layout/dist/isotope.pkgd.js';
import 'lightgallery/dist/js/lightgallery-all';
import 'imagesloaded/imagesloaded.pkgd.js';
import 'select2/dist/js/select2.js';
import "velocity-animate/velocity.min.js";
import "velocity-animate/velocity.ui.min.js";
import "sticky-kit/dist/sticky-kit.min.js";

fontawesome.library.add(light);



jQuery(function ($) {
	"use strict";

	function myAddParameterAndReturn(url, paramName, paramValue)
	{
	    if (url.indexOf(paramName + "=") >= 0)
	    {
	        var prefix = url.substring(0, url.indexOf(paramName));
	        var suffix = url.substring(url.indexOf(paramName));
	        suffix = suffix.substring(suffix.indexOf("=") + 1);
	        suffix = (suffix.indexOf("&") >= 0) ? suffix.substring(suffix.indexOf("&")) : "";
	        url = prefix + paramName + "=" + paramValue + suffix;
	    }
	    else
	    {
	    if (url.indexOf("?") < 0)
	        url += "?" + paramName + "=" + paramValue;
	    else
	        url += "&" + paramName + "=" + paramValue;
	    }
	    return url;
	}

	var geoMarkers = [];
	var googleMapMarkers = [];

	function is_touch_device() {
	  return 'ontouchstart' in window        // works on most browsers 
	      || navigator.maxTouchPoints;       // works on IE10/11 and Surface
	};

	function requestMarkers(map, url, oms){
	    deleteMarkers();
	    $.ajax({
	      dataType: "json",
	      url: url,
	    }).done(function(json) {
	      $.each(json, function(index, elem){
	       // console.log(elem);
	        geoMarkers.push({
	             "type": "Feature",
	             "geometry": {
	                 "type": "Point",
	                 "coordinates": [
	                     elem.address.lng,
	                     elem.address.lat
	                 ]
	             },
	             "properties": {
	                 "postid" : elem.post.ID,
	                 "link": elem.permalink,
	                 "marker": elem.markerIcon
	             }
	         });
	      });
	      oms.removeAllMarkers();
	      setMarkers(map, geoMarkers, oms);
	    })
	}

	
	function setMarkers(map, geoMarkers, oms){
	    var geojson =
	    {
	        "type": "FeatureCollection",
	        "features": geoMarkers
	        
	    };

	    
	    //console.log(geojson);
	    if (geojson.features.length >= 1) {
	        var bounds = new google.maps.LatLngBounds();	        
	        geojson.features.forEach(function(feature) {
	          if (feature.geometry.coordinates[1] && feature.geometry.coordinates[0]) {
	            var icon = new google.maps.MarkerImage(
	                        feature.properties.marker,
	                        new google.maps.Size(28,39),
	                        null,
	                        null,
	                        new google.maps.Size(28,39)
	                    );
	            
	            var markerpos = new google.maps.LatLng(feature.geometry.coordinates[1], feature.geometry.coordinates[0]);
	            var marker = new google.maps.Marker({
	              position: markerpos,
	              map: map,
	              title: '',
	              animation: google.maps.Animation.DROP,
	              url: feature.properties.link,
	              icon: icon
	            });

	            oms.addMarker(marker);
	            //googleMapMarkers.push(marker);
	          //  console.log(feature)
	            google.maps.event.addListener(marker, 'spider_click', function() {
	                window.open(this.url);
	            });
	            bounds.extend(markerpos);
	            }
	        });
	        google.maps.event.trigger(map, "resize");
	        $('.loadingOverlay').hide();
	        if (geoMarkers.length > 1) {
	          map.fitBounds(bounds);
	          setTimeout(function(){
	          	map.setZoom(map.getZoom() - 1);
	          }, 100)
	          
	        } else {
	          map.fitBounds(bounds);
	          map.setZoom(12);
	        }
	    };
	}

	function deleteMarkers() {
	    for (var i = 0; i < googleMapMarkers.length; i++) {
	        googleMapMarkers[i].setMap(null);
	    }
	    googleMapMarkers = [];
	    geoMarkers  = [];
	}



	function make_sticky() {
		$(".sticky-col .contentInner").stick_in_parent();
	}

	// Call the sticky function
	if ($(window).width() < 992) {
		$("#sidebar").trigger("sticky_kit:detach");
	} else {
		make_sticky();
	}

	function endsWith(string, search){
		return string.substring( string.length - search.length, string.length ) === search;
	}

/* 	function highlightProjectUnit($headerRow, speed){
		speed = typeof speed !== 'undefined' ? speed : 0;
		var id = "#"+$headerRow.prop('id');
		$('.complex-project-graphic-interaction a').each(function(iindex, iel) {
			if (endsWith($(iel).attr("xlink:href"), id)) {
				//addClass
				$(iel).attr('class', function(index, classNames) {
					var re = /active/gi;
					classNames = classNames.replace(re, '');
					return classNames + ' active';
				});
			}
		});
		$('.complex-custom-overlays img').not('.active').fadeOut(speed);
		var $targetOverlay = $('.complex-custom-overlays img[data-show-on-active-unit="'+id+'"]');
		$targetOverlay.addClass('active').fadeIn(speed);

		//lazy load
		if ($targetOverlay.data('src')) {
			$targetOverlay.prop('src', $targetOverlay.data('src'));
			$targetOverlay.data('src', null);
		}

		$('.complex-tooltip-unit-item').hide();
		if ($('.complex-project-graphic:hover').length !== 0) {
			$('.complex-tooltip-unit-item[data-unit="'+id+'"]').closest('.complex-tooltip').show();
		}
		$('.complex-tooltip-unit-item[data-unit="'+id+'"]').show();
	}

	function scrolltoheaderRow($headerRow, offset){

		//console.log('scrolltoheaderrow');

		jQuery('.complex-tooltip').hide();
		offset = typeof offset !== 'undefined' ? offset : 0;
		var $tr = $headerRow;

		if($tr.parents('.complex-list-wrapper-outer').length){

			//console.log('cxm-wrapper-outer offset: ' + $tr.parents('.complex-list-wrapper-outer').offset().top);

			jQuery('html, body').animate({
				scrollTop: $tr.parents('.complex-list-wrapper-outer').offset().top - offset
			}, 500);

			var $scrollPosition = jQuery('.complex-list-wrapper-outer').scrollTop();

			jQuery('.complex-list-wrapper-outer').scrollTop(0);

			// console.log('headerrow offset to complex-list-wrapper: ' + $tr.position().top);
			// console.log('complex-list-wrapper offset: ' + $tr.parents('.complex-list-wrapper').position().top);
			var $offsetHeaderRow = $tr.position().top;
			var $offsetListWrapper = $tr.parents('.complex-list-wrapper').position().top;

			jQuery('.complex-list-wrapper-outer').scrollTop($scrollPosition);


			var $offsetTotal = $offsetHeaderRow + $offsetListWrapper -  offset;

			//$('.complex-list-wrapper-outer').scrollTop($offsetTotal);

			jQuery('.complex-list-wrapper-outer').animate({
				scrollTop: $offsetTotal
			}, 1000);

		} else {
			jQuery('html, body').animate({
				scrollTop: $tr.offset().top - offset
			}, 500);
		}
	}


	function activateProjectUnit($headerRow){
		//console.log('activateprojectunit');
		$('.complex-tooltip').hide();
		$('.complex-project-graphic-interaction a').each(function(index, el) {
			// removeClass
			$(el).attr('class', function(index, classNames) {
				var re = /active/gi;
				classNames = classNames.replace(re, '');
				return classNames;
			});
		});

		if ($headerRow.hasClass('active')) {
			$headerRow.next().find('.detail-row-wrapper').slideUp('slow');
			$headerRow.removeClass('active');
			$headerRow.next().removeClass('active');
		} else {
			$headerRow.next().find('.detail-row-wrapper img').each(function(index, el) {
				if ($(el).data('src')) {
					$(el).prop('src',$(el).data('src'));
					$(el).prop('srcset',$(el).data('src'));
					$(el).data('src', null);
				}
			});

			scrolltoheaderRow($headerRow, getCXMscrollOffset());

			$('.complex-unit-header-row.active').each(function(index, el) {

				$(el).next().find('.detail-row-wrapper').slideUp('slow');
				$(el).removeClass('active');
				$(el).next().removeClass('active');
			});


			$headerRow.next().find('.detail-row-wrapper').delay(300).slideDown('slow');
			$headerRow.addClass('active');
			$headerRow.next().addClass('active');

			// $('html, body').animate({
			//        scrollTop: $headerRow.next().find('.detail-row-wrapper').offset().top - 100
			//    }, 500);

			highlightProjectUnit($headerRow);
		}
	} */

	

	//$( '.complex-list-wrapper' ).wrap( '<div class="complex-list-wrapper-outer"></div>' );
	
	$('.gallery').lightGallery({
		selector: '.gallery-item a'
	});

	$('.galleryInner').lightGallery({
		selector: '.galItem'
	});

	$('.casawp-carousel').lightGallery({
		selector: '.property-image-gallery',
		download: false,
		thumbnail: false
	});

	// $( ".detail-row-wrapper > a" ).wrapAll( "<div class='complexButtonWrap' />");

	$('.detail-row-wrapper').append('<div class="row"><div class="col-lg-6 leftCol cxmButtonsWrap"></div><div class="col-lg-6 rightCol cxmButtonsWrap"></div></div>');

	

	$('.detail-row-wrapper .btn').each(function(index, ul){
				
		var $right = $(ul).parent().find('.pull-right');
		if ($right.length) {
			$($right).appendTo($(ul).parent().find('.rightCol'));
		}
				
		var $left = $(ul).parent().find('.pull-left');
		if ($left.length) {
			$($left).appendTo($(ul).parent().find('.leftCol'));
		}
		
	});

	$('.complex-call-contact-form').on('click', function(event) {
		event.preventDefault();
		var unit_id = $(this).data('unit-id');
		$('#complexContactForm form [name="complex-unit-inquiry[unit_id]"]').val(unit_id).prop('disabled','disabled');
		$('#complexContactForm').appendTo($(this).parent().parent().parent());

		//$("#complexContactForm input:text, #complexContactForm textarea").first().focus();
		$('.complex-sendback-contact-form').show();

		$(this).hide();
	});


	$('.casadistance__menu__button').on('click', function(){
		$('html, body').animate({
			scrollTop: $('.casadistance__menu').offset().top
		}, 500);
	});

	$('.navbar-toggler').on('click', function(){
		if ($(this).hasClass('active-nav')) {
			$(this).removeClass('active-nav');
			$('.navbarOuter').removeClass('nav-bg');
		} else {
			$(this).addClass('active-nav');
			$('.navbarOuter').addClass('nav-bg');
		}
	});

	$('.navbar-collapse').on('shown.bs.collapse', function(){
		$('#footer').hide();
		$('#content').hide();
		$('.sliderOuter').hide();

	});

	$('.navbar-collapse').on('show.bs.collapse', function(){
		$('html, body').animate({
			scrollTop: $('html, body').offset().top
		}, 500);
		$('#header').css('position', 'absolute');
		$('html').addClass('navBackground');
	});

	$('.navbar-collapse').on('hidden.bs.collapse', function(){
	});

	$('.navbar-collapse').on('hide.bs.collapse', function(){
		$('#header').css('position', 'fixed');
		$('#footer').show();
		$('#content').show();
		$('.sliderOuter').show();
		$('html').removeClass('navBackground');
	});

	$('#navigation .menu-item-has-children > a').on('click', function(e){
		e.preventDefault();
		$(this).hover();
		return false;
	});

	$('.wpml-ls > ul > li > a').on('click', function(e){
		e.preventDefault();
		$(this).hover();
		return false;
	});

	$('.complex-unit-caret-cell').append('<svg width="9px" height="5px" viewBox="0 0 9 5" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><g id="Symbols" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g id="Line" transform="translate(-673.000000, -10.000000)" fill="#4A4A4A"><path d="M681.89,10.1043508 C681.742584,9.96521639 681.504017,9.96521639 681.357351,10.1043508 L677.499766,14.132115 L673.642931,10.1043508 C673.495889,9.96521639 673.257322,9.96521639 673.110281,10.1043508 C672.96324,10.2470529 672.96324,10.4753761 673.110281,10.6145105 L677.21506,14.8991383 C677.293458,14.9740568 677.397362,15.0061648 677.499766,14.9990297 C677.602544,15.0061648 677.706449,14.9740568 677.785221,14.8991383 L681.89,10.6145105 C682.036667,10.4753761 682.036667,10.2470529 681.89,10.1043508" id="Fill-3"></path></g></g></svg>')

	var textTop = $('.casawp-shortcode-properties-shortcode-list .casawp-property').outerHeight() - $('.casawp-shortcode-properties-shortcode-list .casawp-property .casawp-text h3').outerHeight();

	$('.casawp-shortcode-properties-shortcode-list .casawp-property').each(function(index, el){
		textTop = $(el).outerHeight() - $(el).find('h3').outerHeight();
		$(el).find('.casawp-text').css('top', textTop);
	});

	

	$('.casawp-shortcode-properties-shortcode-list .casawp-property').on('click', function(){
		if ($(this).hasClass('activeProperty')) {
			$(this).removeClass('activeProperty');
		} else {
			$('.casawp-shortcode-properties-shortcode-list .casawp-property').removeClass('activeProperty');
			$(this).addClass('activeProperty');
		}
	});

	$(window).on('scroll', function(){
		if ($('body').hasClass('page-template-home')) {
			if ($(window).scrollTop() > $('.homeSlider').outerHeight() - $('#header').outerHeight()) {
				$('#header').removeClass('homeHeader');
			} else {
				$('#header').addClass('homeHeader');
			}
		}
	});

	if ($('body').hasClass('page-template-home')) {
		if ($(window).scrollTop() > $('.homeSlider').outerHeight()) {
			$('#header').removeClass('homeHeader');
		} else {
			$('#header').addClass('homeHeader');
		}
	}
	


	if (!$('.navbar-collapse').hasClass('show')) {
		var myElement = document.querySelector("#header");
		// construct an instance of Headroom, passing the element
		var headroom  = new Headroom(myElement, {
			"offset": 205,
				"tolerance": 5,
				"classes": {
				"initial": "animated",
				"pinned": "slideDown",
				"unpinned": "slideUp"
				}
		});
		// initialise
		headroom.init();
	}

	if ($('.casawp-shortcode-properties').length) {
		var shortFlickity = new Flickity('.casawp-shortcode-properties', {
			cellAlign: 'left',
			contain: true,
			imagesLoaded: true,
			pageDots: true,
			prevNextButtons: false,
			draggable: true,
			autoPlay: 7000
		});
		if (shortFlickity.slides.length <= 2) {
			$('.flickity-page-dots').hide();
		}
	}

	if ($('.co_slider').length) {
		var slider = new Flickity('.co_slider', {
			cellAlign: 'left',
			wrapAround: true,
			imagesLoaded: true,
			pageDots: false,
			prevNextButtons: false,
			draggable: false,
			autoPlay: 7000
		});
	}
	

	if ($('.grid').length) {
		var $grid = $('.grid').isotope({
			itemSelector: '.grid-item'
		});

		$grid.imagesLoaded().progress( function() {
			$grid.isotope({
				itemSelector: '.grid-item'
			});
		});
	}
	
	if ($('.filters-select').length) {
		$('.filters-select').select2();

		$('.filters-select').on( 'change', function() {
			// get filter value from option value
			
			var maxHeight = 0;

			$('.grid-item').each(function(){
				var thisH = $(this).height();
				if (thisH > maxHeight) { maxHeight = thisH; }
			});

			$('.grid-item').height(maxHeight);
			var filterValue = this.value;
			// console.log(filterValue);
			// use filterFn if matches value
			$grid.isotope({ filter: filterValue });
			
		});
	} 	


/* 	var dragging = false;
	$("body").on("touchmove", function(){
			dragging = true;
	});
	$("body").on("touchstart", function(){
		dragging = false;
	});


	$(".complex-unit-header-row").off('click');
	$('.complex-unit-header-row').off('click touchend');

	$('.complex-unit-header-row').on('click touchend', function(event) {
		var row = this;
		var anchorclick = $(event.target).is('a');
		if (!anchorclick) {
			event.preventDefault();

			if (!dragging) {
				if ($('.complex-list-wrapper').hasClass('complex-list-wrapper-collapsible')) {
					$('.complex-custom-overlays img').removeClass('active').hide();
					activateProjectUnit($(this));
				} else {

					if ($('.complex-contact-form-wrapper').length) {
						// $('html, body').animate({
					//       scrollTop: $('.complex-contact-form-wrapper').offset().top
					//   }, 500);
					$(".complex-contact-form-wrapper input:text, .complex-contact-form-wrapper textarea").first().trigger('focus');
					var unit_id = $(row).data('unit-id');
					$('.complex-contact-form-wrapper form [name="complex-unit-inquiry[unit_id]"]').val(unit_id);
					//.prop('disabled','disabled')


					} else if($(row).find('.col-quick-download a').length){
						$(row).find('.col-quick-download a').first()[0].trigger('click');
					} else if($(row).find('.col-quick-download').length){
						//silence
					} else {
						alert('form not found add it with [contactform-complex] or enable collapsible="1" property on [CXM-list] and make sure there is only one form available.');
					}
				}
			}
		}
	}); */



	$('.chosen-single, .select2-selection').append('<i class="fal fa-angle-down"></i>');

	$('.main-menu .menu-item-has-children > a, .wpml-ls-item a:first').append('<i class="fal fa-angle-down"></i>');

	$('<i class="fal fa-angle-down"></i>').insertAfter('.form-control-singleselect').hide();

	if (is_touch_device()) {
		$('.form-control-singleselect').nextAll().show();
	}

	$('.form-group select').parent().append('<i class="fal fa-angle-down"></i>');

	function initializeMapBoxCasaWP() {

		var style = [
			{
			"elementType": "geometry",
			"stylers": [
				{
				"color": "#f5f5f5"
				}
			]
			},
			{
			"elementType": "labels.icon",
			"stylers": [
				{
				"visibility": "off"
				}
			]
			},
			{
			"elementType": "labels.text.fill",
			"stylers": [
				{
				"color": "#616161"
				}
			]
			},
			{
			"elementType": "labels.text.stroke",
			"stylers": [
				{
				"color": "#f5f5f5"
				}
			]
			},
			{
			"featureType": "administrative.land_parcel",
			"elementType": "labels.text.fill",
			"stylers": [
				{
				"color": "#bdbdbd"
				}
			]
			},
			{
			"featureType": "poi",
			"elementType": "geometry",
			"stylers": [
				{
				"color": "#eeeeee"
				}
			]
			},
			{
			"featureType": "poi",
			"elementType": "labels.text.fill",
			"stylers": [
				{
				"color": "#757575"
				}
			]
			},
			{
			"featureType": "poi.park",
			"elementType": "geometry",
			"stylers": [
				{
				"color": "#e5e5e5"
				}
			]
			},
			{
			"featureType": "poi.park",
			"elementType": "labels.text.fill",
			"stylers": [
				{
				"color": "#9e9e9e"
				}
			]
			},
			{
			"featureType": "road",
			"elementType": "geometry",
			"stylers": [
				{
				"color": "#ffffff"
				}
			]
			},
			{
			"featureType": "road.arterial",
			"elementType": "labels.text.fill",
			"stylers": [
				{
				"color": "#757575"
				}
			]
			},
			{
			"featureType": "road.highway",
			"elementType": "geometry",
			"stylers": [
				{
				"color": "#dadada"
				}
			]
			},
			{
			"featureType": "road.highway",
			"elementType": "labels.text.fill",
			"stylers": [
				{
				"color": "#616161"
				}
			]
			},
			{
			"featureType": "road.local",
			"elementType": "labels.text.fill",
			"stylers": [
				{
				"color": "#9e9e9e"
				}
			]
			},
			{
			"featureType": "transit.line",
			"elementType": "geometry",
			"stylers": [
				{
				"color": "#e5e5e5"
				}
			]
			},
			{
			"featureType": "transit.station",
			"elementType": "geometry",
			"stylers": [
				{
				"color": "#eeeeee"
				}
			]
			},
			{
			"featureType": "water",
			"elementType": "geometry",
			"stylers": [
				{
				"color": "#c9c9c9"
				}
			]
			},
			{
			"featureType": "water",
			"elementType": "labels.text.fill",
			"stylers": [
				{
				"color": "#9e9e9e"
				}
			]
			}
		]

		var mapOptions = {
			center: {lat: 47.247913, lng: 8.674145},
			zoom: 14,
			disableDefaultUI: false,
			zoomControl: true,
			mapTypeControlOptions: {
					mapTypeIds: ['roadmap', 'hybrid']
				},
			styles: style
		};
		var map = new google.maps.Map(document.getElementById('casawp-map'), mapOptions);

		var oms = new OverlappingMarkerSpiderfier(map, {
			markersWontMove: false,
			markersWontHide: false,
			basicFormatEvents: false
		});

		// set gray style
		map.mapTypes.set('gray_map',
			new google.maps.StyledMapType([{stylers: [{saturation: -90}]}],
				{name: "Karte"}));
		map.setMapTypeId('gray_map');
		
		if ($('.casawp-property').length > 0) {
			$('.loadingOverlay').removeAttr('style');
		}
		
		if (!$('.casawp-archive').hasClass('refArchive')) {
			var $form = $('.casawp-filterform');
			var filteredParams = $form.serialize();
			var url = $form.prop('action');
			url = url.replace(window.location.protocol + "//" + window.location.host, '');

			var filteredUrl = myAddParameterAndReturn(url + '?' + filteredParams, 'ajax', '1');
			filteredUrl = filteredUrl + '&posts_per_page=999&json=1';
			console.log(filteredUrl);
			requestMarkers(map, filteredUrl, oms);

			$('.casawp-filterform').on( "casawp-ajaxfilter:filter-submit", function(event, url, filteredUrl){
				requestMarkers(map, filteredUrl+"&ajax=1&posts_per_page=999&json=1", oms);
			});
		} else {
			requestMarkers(map, '/immobilien/?availabilities%5B%5D=reference&salestypes=&utilities=&categories=&locations=&rooms_from=&rooms_to=&features=&ajax=1&posts_per_page=100&json=1', oms);
		}
	}

	if ($('#casawp-map').length) {
		initializeMapBoxCasaWP();
	};


	$('#chooseForm').on('submit', function(event){
		event.preventDefault();
		$.ajax({
			type: "GET",
			url: window.location.href,
			data: {distance: 'distance'},
			success: function(data){
				initMap();
			}
		});
	});


	$('.casawp-ajax-archive-list').on( "casawp-ajaxfilter:after-list-reload", function(event, url, filteredUrl){
		setTimeout(function(){
		$('.chosen-single').append('<i class="fal fa-angle-down"></i>');
		}, 500);
		var width = $(window).width(); 
		if (width <= 768) {
			$('html, body').animate({
			scrollTop: $('.contentWrap').offset().top
			}, 1000);
		}
		
	});

	function initializeMap($mapwraper) {
		if ($('.marker').length) {
			var markerIcon = $('.marker').data('marker');
		}
		var location = new google.maps.LatLng($mapwraper.data('lat'),$mapwraper.data('lng'));
		var mapOptions = {
			zoom: parseInt(window.casawpOptionParams.google_maps_zoomlevel),
			mapTypeId: google.maps.MapTypeId.ROADMAP,
			center: location,
			mapTypeControlOptions: {
			mapTypeIds: [google.maps.MapTypeId.ROADMAP, 'gray_map']
			}
		};
		$mapwraper.show();
		var map = new google.maps.Map(document.getElementById('map-canvas'), mapOptions);

		var marker = new google.maps.Marker({
			map: map,
			position: location,
			icon: new google.maps.MarkerImage(
					markerIcon,
					new google.maps.Size(28,39),
					null,
					null,
					new google.maps.Size(28,39)
				)
		});
		map.mapTypes.set('gray_map',
			new google.maps.StyledMapType([{stylers: [{saturation: -90}]}],
				{name: "Gray Map"}));
		map.setMapTypeId('gray_map');
	}
	
	if ($('.casawp-map').length && google) {
		$('.casawp-map').each(function(){
			var $mapwraper = $(this);
			if ($mapwraper.data('lat') && $mapwraper.data('lng')) {
				//var map;
				if ($('#casawp-mapShowBtn').length) {
					$('#casawp-mapShowBtn').on('click', function() {
						console.log("click");
						if ($('#casawp-mapShowBtn').length) {
							$('#casawp-mapShowBtn').css('display', 'none');
						}
						if ($('.casawp-map__placeholder').length) {
							$('.casawp-map__placeholder').css('display', 'none');
						}
						$('.casawp-map').css('display', 'block');
						initializeMap($mapwraper);
					});
				} else {
					initializeMap($mapwraper);
				}
			}
		});
	}

	var wpformsRadioLiLabel = document.querySelectorAll('.wpforms-field-radio li label');
	if (wpformsRadioLiLabel.length) {
		for (let i = 0; i < wpformsRadioLiLabel.length; i++) {
			wpformsRadioLiLabel[i].insertAdjacentHTML('afterend', '<span class="checkmark"></span>');
		}
	}

	setTimeout(function(){
		$('.choices__inner').append('<svg class="svg-inline--fa fa-angle-down fa-w-8" aria-hidden="true" data-prefix="fal" data-icon="angle-down" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 512" data-fa-i2svg=""><path fill="currentColor" d="M119.5 326.9L3.5 209.1c-4.7-4.7-4.7-12.3 0-17l7.1-7.1c4.7-4.7 12.3-4.7 17 0L128 287.3l100.4-102.2c4.7-4.7 12.3-4.7 17 0l7.1 7.1c4.7 4.7 4.7 12.3 0 17L136.5 327c-4.7 4.6-12.3 4.6-17-.1z"></path></svg>');
	}, 100)
	

});



// WEBPACK FOOTER //
// ./src/js/main.js